export default __webpack_public_path__ + "assets/58ba97682f6e035923432ee15350d66d.png";